// extracted by mini-css-extract-plugin
export default {"container":"CampaignList_container__tG1LB","table-header-row":"CampaignList_table-header-row__SnEhQ","table-create-button":"CampaignList_table-create-button__X-5fS"};